export default {"src":"/_next/static/media/US.02e4fc91.svg","height":355,"width":512,"blurWidth":0,"blurHeight":0};